import services from '.'
import { IActivationTime, IData, INewActivationTime } from '../@types'
import { getAxiosErrorMessage } from '../resources'

async function get(): Promise<IActivationTime | undefined> {
  try {
    const data = await services.api
      .get<IData<Array<IActivationTime>>>('/activationTimes')
      .then(({ data }) => {
        return data?.data
      })

    if (data && data.length > 0) return data[0]
    return { time: 0, paymentAmount: 0 } as IActivationTime
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function set(data: INewActivationTime): Promise<void> {
  try {
    await services.api.post('/activationTimes', data)
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function put(id: string, data: INewActivationTime): Promise<void> {
  try {
    await services.api.put('/activationTimes', { ...data, id })
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}
export default { get, set, put }
